import axios from "axios";
import _ from "lodash";
import { AuthContext } from "../App";

export const api = axios.create({
    baseURL: "https://whatsapp-service.app.praveya.com",
});

api.interceptors.request.use((config) => {
    const auth = AuthContext.authorization;
    if (!auth.isAuthenticated) {
        auth.signinSilent();
    }
    const accessToken = auth.user?.access_token ?? null;
    config.headers = {
        'Authorization': `Bearer ${accessToken}`
    }
    return config;
}, (error) => {
    Promise.reject(error);
});

export const templateFilter = (filter, page = 0, size = 20) => {
    return api.post(`/api/v1/templates/filter`, { ...filter, page: page, size: size }).then(res => res.data).catch(res => console.log(res));
};

export const saveCreative = (request) => {
    return api.post(`/api/v1/creatives`, request).then(res => res.data);
};

export const getAllWABA = () => {
    return api.get(`/api/v1/business-accounts`).then(res => res.data);
};

export const uploadMediaToMeta = (formData) => {
    return api.post(`/api/v1/media-upload/resumable`, formData).then(res => res.data);
};

export const uploadMediaToCreative = (formData) => {
    return api.post(`/api/v1/creatives`, formData).then(res => res.data);
};

export const saveTemplate = ({ template }) => {
    return api.post(`/api/v1/templates`, { ...template }).then(res => res.data);
};

export const creativeDownload = ({ creativeId }) => {
    return api.get(`/api/v1/creatives/${creativeId}/download`, { responseType: 'blob' }).then(res => URL.createObjectURL(res.data));
};

export const updateTemplate = ({ template, updateMeta = true }) => {
    return api.patch(`/api/v1/templates/${template.id}?updateMeta=${updateMeta}`, { ...template }).then(res => res.data);
};

export const deleteTemplate = (id) => {
    return api.delete(`/api/v1/templates/${id}`).then(res => res.data);
};